import { Component, Vue } from "vue-property-decorator";
import { IsDefined, IsNotEmpty, MaxLength, validate } from "class-validator";

import { SideNav } from "@/layout";
import { Lightbox } from "@/components";
import { ErrorCode, ErrorMessage } from "@/constant";
import { HomeworkModel } from "@/models";
import { Common } from "../Common";

export class PaperForm {
    @IsDefined() @IsNotEmpty({ message: "必填" }) @MaxLength(20, { message: "最多輸入20字" }) name = '';
    @IsDefined() @IsNotEmpty({ message: "必填" }) date = '';
    @IsDefined() @IsNotEmpty({ message: "必填" }) cid = "";
    @IsDefined() @IsNotEmpty({ message: "必填" }) sid = "";
    @IsDefined() @IsNotEmpty({ message: "必填" }) clid = "";
    @IsDefined() @IsNotEmpty({ message: "必填" }) tid = "";
    @IsDefined() @IsNotEmpty({ message: "必填" }) grade = "";
    level = "";
    unit = "";
    @IsDefined() @IsNotEmpty({ message: "必填" }) num = 0;
    @IsDefined() @IsNotEmpty({ message: "必填" }) active = "1";
    token = window.localStorage.getItem('adminToken') as string;
}

type response = { [key: string]: unknown };

@Component<AdminHomeworkPaperAddController>({
    components: {
        SideNav, Lightbox
    }
})
export default class AdminHomeworkPaperAddController extends Vue {
    /*定義data 變數 */
    private doubleClick = false;
    private paperForm = new PaperForm();
    private cityList: object = {};
    private schoolList: { [key: string]: any } = {};
    private classList: object = {};
    private teacherList: object = {};
    private gradeList: object = {};
    private levelList: object = {};
    private unitList: response = {};
    private identity = window.localStorage.getItem('admin_identity') as string;
    private token = window.localStorage.getItem('adminToken') as string;

    private errorMsg = "";
    private openLB = false;
    private errNo = 0;

    private errorMsgMap: { [key: string]: string } = {
        name: '',
        date: '',
        cid: '',
        sid: '',
        clid: '',
        tid: '',
        grade: '',
        num: '',
        active: '',
    };

    public async created() {
        if (this.identity == "1") {
            this.cityList = await Common.getSchoolCity(); //取得有分校之縣市
        } else {
            const sid = window.localStorage.getItem('admin_sid') as string;
            this.cityList = await Common.getCity(sid); //取得該分校之縣市
            for (const cont of this.cityList as any) {
                this.paperForm.cid = cont.cid;
            }

            const school = window.localStorage.getItem('admin_school') as string;
            this.schoolList[0] =  {
                sid: sid,
                name: school,
            };
            this.paperForm.sid = sid;
            this.getClass(sid);
        }
        this.gradeList = await Common.getGrade();
    }

    private async getLevel() {
        this.paperForm.level = '';
        this.paperForm.unit = '';
        const grade = this.paperForm.grade;
        this.levelList = await Common.getLevel(grade);
        this.unitList = {};
    }

    private async getUnit() {
        this.paperForm.unit = '';
        this.unitList = await Common.getUnit();
    }

    // 取得 該縣市的分校列表 
    private async getSchool(cid: string) {
        if (this.identity == "1") {
            this.paperForm.sid = '';
            this.paperForm.clid = '';
            this.paperForm.tid = '';
            this.schoolList = await Common.getSchool(cid);
            this.classList = [];
            this.teacherList = [];
        }
    }

    // 取得 該分校的班級列表
    private async getClass(sid: string) {
        this.paperForm.clid = '';
        this.paperForm.tid = '';

        this.classList = await Common.getClass(1, sid, 0);
        this.teacherList = [];
    }

    // 取得 該班級的老師列表
    private async getTeacher(clid: string) {
        this.paperForm.tid = '';
        this.teacherList = await Common.getTeacher(1, clid, 0);
    }

    public async validateAndSubmit() {
        validate(this.paperForm, { skipMissingProperties: true }).then(
            async result => {
                if (result.length !== 0) {
                    this.errorMsgMap = { //先清空error message
                        name: '',
                        date: '',
                        cid: '',
                        sid: '',
                        clid: '',
                        tid: '',
                        grade: '',
                        num: '',
                        active: '',
                    };

                    result.forEach((item, index) => {
                        const error = item.constraints as {
                            [key: string]: string;
                        };
                        Object.keys(error).forEach(key => {
                            this.errorMsgMap[item.property] = error[key]; //放入error message
                        });
                    });
                    return;
                }

                if (!this.doubleClick) {
                    this.doubleClick = true;

                    this.errNo = await HomeworkModel.addPaper(this.paperForm);
                    Common.checkToken(this.errNo);
                    this.openLB = true;
                    this.doubleClick = false;
                    this.errorMsg = ErrorMessage[this.errNo];
                }
            }
        )
    }

    private closeLB() {
        this.openLB = false;
        if (this.errNo === ErrorCode.Success) {
            this.$router.push("/admin/homework/paper");
        }
    }

}
